import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { FaFileExcel } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";

const EditRunbook = ({ show, onHide, datas, fileNames }) => {
  const [tableData, setTableData] = useState(datas || []);
  const [isSaving, setIsSaving] = useState(false);
  const [editingCell, setEditingCell] = useState(null);

  if (!datas || !fileNames) {
    return (
      <div className="container mt-4">
        <p className="alert alert-warning">No data available for editing.</p>
        <button className="btn btn-secondary" onClick={onHide}>
          Go Back
        </button>
      </div>
    );
  }

  const handleCellClick = (rowIndex, key) => {
    setEditingCell({ rowIndex, key }); // Set the cell being edited
  };

  const handleCellChange = (rowIndex, key, value) => {
    const updatedData = [...tableData];
    updatedData[rowIndex][key] = value;
    setTableData(updatedData);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      // Convert updated data to Excel file
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(tableData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      const fileBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      // Create FormData object
      const formData = new FormData();
      formData.append("file", new Blob([fileBuffer]), fileNames);

      // Upload updated file
      const response = await axios.post(
        `https://drdashboard.4blabs.com/runbook/file/update/${fileNames}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status === 200) {
        toast.success("File updated successfully!");
        // navigate(-1); // Navigate back after saving
        onHide();
      }
    } catch (error) {
      console.error("Error saving file:", error);
      toast.error("Failed to save the file.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0">
          <FaFileExcel className="text-successbg me-2" />
          {fileNames}
        </h6>
        <div className="d-flex ">
          {/* <button className="btn webbg p-0 me-2 rounded-circle w-40 d-flex justify-content-center align-items-center">
  //           <MdEdit />
  //         </button> */}
          <button
            className={`btn btn-success me-2 rounded-pill ${
              isSaving
                ? ""
                : "w-40 d-flex justify-content-center align-items-center p-0"
            }`}
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : ""}{" "}
            <FaSave className={`text-white ${isSaving ? "ms-2" : "ms-0"}`} />
          </button>
        </div>
      </div>

      <div className="table-responsive mx-auto-scroll">
        <table className="table table-bordered table-striped runbook-table">
          <thead className="table-primary">
            <tr>
              {tableData.length > 0 &&
                [...new Set(tableData.flatMap((row) => Object.keys(row)))].map(
                  (key) => (
                    <th key={key} className="text-uppercase text-center">
                      {key}
                    </th>
                  )
                )}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {Object.keys(row).map((key, cellIndex) => (
                  <td
                    key={cellIndex}
                    className="align-middle text-center"
                    onClick={() => handleCellClick(rowIndex, key)}
                    style={{
                      minWidth: "150px",
                      whiteSpace: "nowrap",
                      padding: "10px",
                      cursor: "pointer",
                    }}
                  >
                    {editingCell &&
                    editingCell.rowIndex === rowIndex &&
                    editingCell.key === key ? (
                      <input
                        type="text"
                        value={row[key]}
                        onChange={(e) =>
                          handleCellChange(rowIndex, key, e.target.value)
                        }
                        onBlur={() => setEditingCell(null)}
                        autoFocus
                        className="form-control form-control-sm"
                      />
                    ) : (
                      row[key]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EditRunbook;
